import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as APIS from "../../../../../services/apis";

export function* handleFetchCompanyDetails({ payload }) {
  try {
    const res = yield call(APIS.fetchCompanyDetails, payload);
    const { data } = res;
    yield put(actions.fetchCompanyDetailsSuccess(data));
  } catch (err) {
    yield put(actions.fetchCompanyDetailsFailure(err?.response?.data));
  }
}

export function* handleFetchCompanyPickupAddress({ payload }) {
  try {
    const res = yield call(APIS.fetchPickupAddressForCompany, payload);
    const { data } = res;
    yield put(actions.fetchCompanyPickupAddressSuccess(data));
  } catch (err) {
    yield put(actions.fetchCompanyPickupAddressFailure(err?.response?.data));
  }
}

export function* handleFetchCompanyBillingAddress({ payload }) {
  try {
    const res = yield call(APIS.fetchBillingAddressForCompany, payload);
    const { data } = res;
    yield put(actions.fetchCompanyBillingAddressSuccess(data));
  } catch (err) {
    yield put(actions.fetchCompanyBillingAddressFailure(err?.response?.data));
  }
}

export function* handleFetchCountries({ payload }) {
  try {
    const res = yield call(APIS.fetchAllCountries, payload);
    const { data } = res;
    yield put(actions.fetchCountriesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCountriesFailure(err?.response?.data));
  }
}

export function* handleFetchStates({ payload }) {
  try {
    const res = yield call(APIS.fetchAllStates, payload);
    const { data } = res;
    yield put(actions.fetchStatesSuccess(data));
  } catch (err) {
    yield put(actions.fetchStatesFailure(err?.response?.data));
  }
}

export function* handleFetchCities({ payload }) {
  try {
    const res = yield call(APIS.fetchAllCities, payload);
    const { data } = res;
    yield put(actions.fetchCitiesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCitiesFailure(err?.response?.data));
  }
}

export function* handleAddAddress({ payload }) {
  try {
    const res = yield call(APIS.addCompanyAddress, payload);
    const { data } = res;
    yield put(actions.addAddressSuccess(data));
    yield put(actions.fetchCompanyDetails({ id: payload.id }));
    payload.onSuccess();
  } catch (err) {
    yield put(actions.addAddressFailure(err?.response?.data));
  }
}

export function* handleUpdateAddress({ payload }) {
  try {
    const res = yield call(APIS.updateAddress, payload);
    const { data } = res;
    yield put(actions.updateAddressSuccess(data));
    yield put(actions.fetchCompanyDetails({ id: payload.companyId }));
    payload.onSuccess();
  } catch (err) {
    yield put(actions.updateAddressFailure(err?.response?.data));
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* viewCompanySaga() {
  yield takeLatest(actions.fetchCompanyDetails.type, handleFetchCompanyDetails);
  yield takeLatest(actions.fetchCountries.type, handleFetchCountries);
  yield takeLatest(actions.fetchStates.type, handleFetchStates);
  yield takeLatest(actions.fetchCities.type, handleFetchCities);
  yield takeLatest(
    actions.fetchCompanyPickupAddress.type,
    handleFetchCompanyPickupAddress
  );
  yield takeLatest(
    actions.fetchCompanyBillingAddress.type,
    handleFetchCompanyBillingAddress
  );
}
